import { render, staticRenderFns } from "./FranchiseStrength.vue?vue&type=template&id=4f7979e0&scoped=true"
import script from "./FranchiseStrength.vue?vue&type=script&lang=js"
export * from "./FranchiseStrength.vue?vue&type=script&lang=js"
import style0 from "./FranchiseStrength.vue?vue&type=style&index=0&id=4f7979e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7979e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
